import { useState, useCallback } from 'react';
import { toast } from 'sonner';

/**
 * Bundles modal state + CRUD callbacks for a list page.
 *
 *  const { open, editing, onCreate, onEdit, onDelete, closeModal, save } = useCrudActions({
 *    api: workersApi,
 *    label: 'lavoratore',
 *    onChange: reload,
 *  });
 */
export function useCrudActions({ api, label = 'elemento', onChange }) {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const onCreate = useCallback((defaults = {}) => {
    setEditing(defaults);
    setOpen(true);
  }, []);

  const onEdit = useCallback((row) => {
    setEditing(row);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
    setEditing(null);
  }, []);

  const save = useCallback(async (values) => {
    if (editing && editing.id) {
      await api.update(editing.id, values);
      toast.success(`${label.charAt(0).toUpperCase() + label.slice(1)} aggiornato`);
    } else {
      await api.create(values);
      toast.success(`${label.charAt(0).toUpperCase() + label.slice(1)} creato`);
    }
    closeModal();
    if (onChange) onChange();
  }, [api, label, editing, onChange, closeModal]);

  const onDelete = useCallback(async (row) => {
    if (!row?.id) return;
    const name = row.name || row.title || row.titolo || row.corso || row.tipo || row.id;
    if (!window.confirm(`Confermi eliminazione di "${name}"?`)) return;
    try {
      await api.remove(row.id);
      toast.success(`${label.charAt(0).toUpperCase() + label.slice(1)} eliminato`);
      if (onChange) onChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore eliminazione');
    }
  }, [api, label, onChange]);

  return { open, setOpen, editing, onCreate, onEdit, onDelete, closeModal, save };
}
